module.exports = __webpack_public_path__ + "img/kachel-ERSCHOEPFUNG_REISHI.7ac3b2b8.png";